import { render } from "./SiteCalendar.vue?vue&type=template&id=f753bcd8"
import script from "./SiteCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteCalendar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f753bcd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f753bcd8', __exports__)) {
    api.reload('f753bcd8', __exports__)
  }
  
  module.hot.accept("./SiteCalendar.vue?vue&type=template&id=f753bcd8", () => {
    api.rerender('f753bcd8', render)
  })

}


export default __exports__